/**
 * Which app this bundle is. Deliberately a LEAF module: it imports nothing.
 *
 * These flags also live on `helpers.tsx` (which re-exports them, so there is
 * still one definition), but that file pulls in `../routes` and
 * `../adminComponents`, and `routes` imports the `adminPages` barrel. Anything
 * eagerly evaluated - the `hooks` barrel, or a module reachable from
 * `adminPages` - that reaches for `isAdmin` through `helpers.tsx` therefore
 * closes an import cycle, and whichever module loses the race ends up with
 * `undefined` bindings and renders nothing.
 *
 * Import app-type flags from here in any module that is loaded eagerly.
 */
export const APP_TYPE = process.env.NX_APP_TYPE || '';

export const isAdmin = APP_TYPE === 'admin';
export const isPartner = APP_TYPE === 'partner';
export const isSales = APP_TYPE === 'sales';
export const isBrandOwner = APP_TYPE === 'brandOwner';
export const isDeliveries = APP_TYPE === 'deliveries';
/** The public marketing site (apps/vgrubs sets it in next.config.js). */
export const isWebsite = APP_TYPE === 'website';

/** The apps that initialise Firebase messaging and register for web push. */
export const isPushApp = isAdmin || isPartner;

/**
 * The apps that start Firebase messaging at all: the two above, plus the vDrive
 * console, whose bell comes as web push. The console has its own push hook -
 * `isPushApp` stays the gate for the vGrubs one in the shared layout.
 */
export const hasFirebaseMessaging = isPushApp || isDeliveries;
